import { render, staticRenderFns } from "./Forgotten.vue?vue&type=template&id=4b5a8004&scoped=true&"
import script from "./Forgotten.vue?vue&type=script&lang=js&"
export * from "./Forgotten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a8004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5a8004')) {
      api.createRecord('4b5a8004', component.options)
    } else {
      api.reload('4b5a8004', component.options)
    }
    module.hot.accept("./Forgotten.vue?vue&type=template&id=4b5a8004&scoped=true&", function () {
      api.rerender('4b5a8004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Auth/Forgotten.vue"
export default component.exports